import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './routes'
// import Mock from './mock'
import 'font-awesome/css/font-awesome.min.css'

import store from './vuex/store'
import Vuex from 'vuex'
import QuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'
import VueAMap from 'vue-amap'
Vue.use(QuillEditor)
// Mock.bootstrap()
Vue.use(ElementUI)
Vue.use(VueAMap)
Vue.use(Vuex)
VueAMap.initAMapApiLoader({
  key: 'e7baed0cb392b7b7b9f2bc0dedb29d10', // 申请的key码需要填写的地方，格式为长串字符数字
  plugin: ['AMap.ToolBar', 'AMap.PlaceSearch', 'AMap.Geolocation', 'AMap.Geocoder'],
  v: '1.4.4'
})
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    sessionStorage.removeItem('user')
  }
  let user = JSON.parse(sessionStorage.getItem('user'))
  if (!user && to.path !== '/login' &&
      to.path !== '/addCompaniesUserByQr' &&
      to.path !== '/camera' &&
      to.path !== '/examination' &&
      to.path !== '/driverTrainStudy') {
    next({ path: '/login' })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
